<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>

      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Promociones</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Admin_ 01_Prom</div>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="subtitulos">
          Administración de promociones
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-row class="m-3" align-v="center" align-h="end">
            <b-col>

              <b-form-group align="left">
                <label for="nombreBusq">Palabra clave</label>
                <b-input-group size="sm" class="mb-2" id="nombreBusq" lab>
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input name="nombre" placeholder="Nombre de promoción"
                                v-model="filtro.palabraClave" @keydown.enter.native="obtenerPromociones"
                  ></b-form-input>
                </b-input-group>
              </b-form-group>

            </b-col>

            <b-col></b-col>

            <b-col align="right" >
              <b-button v-b-tooltip.hover title="Crear Promocion" variant="outline-success"
                        @click="agregar()">Crear promoción
              </b-button>
            </b-col>

          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-table
              id="Pendientes"
              thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="registrosPorPagina"
              :current-page="paginaActual"
              responsive="true"
              class="parrafos"
              fixed>
            <template v-slot:cell(vigencia)="row">
              {{row.item.fechaInicio | formatoFecha}} a
              {{row.item.fechaFin | formatoFecha}}
            </template>
            <template v-slot:cell(Editar)="row">
              <b-button
                  title="Editar promoción"
                  size="sm"
                  @click="modificar(row.item.idPromocion)"
                  variant="warning"
              ><em class="fa fa-pencil"></em></b-button>
            </template>
            <template v-slot:cell(Suspender)="row">
              <b-form-checkbox v-model="row.item.suspendido" switch size="lg" @change="eliminar(row.item)"></b-form-checkbox>
            </template>
          </b-table>
          <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="registrosPorPagina"
                aria-controls="my-table1"
            ></b-pagination>
          </b-col>
        </b-col>


      </b-row>

    </b-container>

  </div>
</template>

<script>
import {PromocionesService} from "../../apiServices/promociones/PromocionesService";
import Header from "../../components/Header";

export default {
  name: "promociones",
  components: {Header},
  promocionesServicio: new PromocionesService(),
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    datosTabla: [],
    fields: [
      {key: "idPromocion", label: "ID", sortable: true},
      {key: "promocion", label: "Promoción", sortable: true},
      {key: "vigencia", label: "Vigencia", sortable: true},
      {key: "estatus", label: "Estatus", sortable: true},
      "Editar",
      "Suspender",
    ],
    registrosPorPagina: 10,
    paginaActual: 0,
    loaderAcciones: false,
    loader: false,
    filtro: {
      id: null,
      palabraClave: null,
      registroActivo: null
    },
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.obtenerPromociones();
  },
  methods:{

    obtenerPromociones(){
      this.$options.promocionesServicio.obtenerListaPromociones(this.filtro).then(respuesta => {
        this.datosTabla = respuesta
      })
    },

    /*
    obtenerPromociones() {
      this.$http.post(this.$api + 'promocion/obtener', this.filtro).then(respuesta => {
          this.datosTabla = respuesta.data.data;
      })
    },

     */

    agregar(){
      this.$router.push({name : 'formularioPromocion',params:{idPromocion: 0}})
    },
    modificar(id){
      this.$router.push({name : 'formularioPromocion',params:{idPromocion: id}})
    },
    eliminar(item){

      this.$swal({
        title: "¿Desea suspender la promoción?",
        icon: "question",
        confirmButtonColor: "#0e6ba9",
        cancelButtonColor: "#8e8e8e",
        confirmButtonText: 'Si',
        cancelButtonText:'No',
        showCancelButton: true,
      }).then((result) => {
        if (result.value) {
          this.enviando = true;
          this.$options.promocionesServicio.suspenderPromocion(item.idPromocion).then( () => {
            this.$swal({
              icon: "success",
              text: "Promoción actualizada",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
          } ).catch(e => {
            console.error(e)
            item.suspendido = !item.suspendido;
          });
        }else{
          item.suspendido = !item.suspendido;
        }
      });
    }
  },
}
</script>

<style scoped>
 .custom-control-label ::before {
  color: #28a745 !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}
</style>